import Hero from '../components/Hero/Hero';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import Cta from '../components/Cta/Cta';
import Footer from '../components/Footer/Footer';
import Seo from '../components/Seo/Seo';
import { DEFAULT_DESCRIPTION, SITE_TAGLINE } from '../config/site';
import { buildWebsiteJsonLd } from '../utils/seo';

function HomePage() {
  return (
    <>
      <Seo
        title={SITE_TAGLINE}
        description={DEFAULT_DESCRIPTION}
        path="/"
        jsonLd={buildWebsiteJsonLd()}
      />
      <Hero />
      <HowItWorks />
      <Cta />
      <Footer />
    </>
  );
}

export default HomePage;
